import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';

function FormSubmitButton({ label, submit }) {
    return <RaisedButton primary label={label || 'Save'} onClick={submit} />;
}

FormSubmitButton.propTypes = {
    label: PropTypes.string,
    submit: PropTypes.func
};

export default FormSubmitButton;



/** WEBPACK FOOTER **
 ** ../src/dash/front/admin/components/Account/UpdateAccount/FormSubmitButton.js
 **/